import { Col, Divider, Row, Statistic, Tooltip } from "antd";
import { observer } from "mobx-react";
import { useStores } from "../../../store";
import { ClockCircleOutlined, FieldTimeOutlined } from "@ant-design/icons";
import { getDecimalSeparator, __ } from "../../../utils";
const AccountAffiliateHeader = observer(() => {
  const {
    accountStore: {
      session
    }
  } = useStores();
  const {
    affiliateError,
    affiliate
  } = session;
  const decimalSeparator = getDecimalSeparator();
  const {
    lang
  } = document.documentElement;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !affiliateError && affiliate && /*#__PURE__*/React.createElement(Row, {
    gutter: [20, 20],
    style: {
      background: "#f7f7f7",
      padding: "15px 30px 15px 20px"
    },
    align: "middle"
  }, affiliate.affiliate.isManuallyReviewed === false && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "topLeft",
    title: __("Your affiliate account is fully usable and you can already earn commissions. However, we will still review your invoice address and payment details. We let you know by email as soon as we reviewed you account!")
  }, /*#__PURE__*/React.createElement(Statistic, {
    title: __("Affiliate status"),
    prefix: /*#__PURE__*/React.createElement(ClockCircleOutlined, {
      style: {
        color: "#569ae1"
      }
    }),
    precision: 0,
    value: __("Review pending")
  }))), /*#__PURE__*/React.createElement(Col, {
    style: {
      height: 30
    }
  }, /*#__PURE__*/React.createElement(Divider, {
    type: "vertical",
    style: {
      height: "100%",
      margin: 0
    }
  }))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "topLeft",
    title: __("Commission will be paid on the 15th of the month following the month in which it was earned, if the payment threshold of %s EUR has been reached.", affiliate.affiliate.payoutThreshold)
  }, /*#__PURE__*/React.createElement(Statistic, {
    title: __("Unpaid commission"),
    suffix: "EUR",
    decimalSeparator: decimalSeparator,
    precision: 2,
    value: affiliate.commissions.totalUnpaid
  }))), /*#__PURE__*/React.createElement(Col, {
    style: {
      height: 30
    }
  }, /*#__PURE__*/React.createElement(Divider, {
    type: "vertical",
    style: {
      height: "100%",
      margin: 0
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "topLeft",
    title: affiliate.affiliate.commissionPlanned ? __("The commission rate will be changed to %d %% on %s.", affiliate.affiliate.commissionPlanned, new Date(affiliate.affiliate.commissionPlannedChangeDate).toLocaleDateString(lang)) : undefined
  }, /*#__PURE__*/React.createElement(Statistic, {
    title: __("Commission rate"),
    suffix: "%",
    prefix: affiliate.affiliate.commissionPlanned ? /*#__PURE__*/React.createElement(FieldTimeOutlined, {
      style: {
        color: "#569ae1",
        cursor: "pointer"
      }
    }) : null,
    precision: 0,
    value: affiliate.affiliate.commission
  }))), /*#__PURE__*/React.createElement(Col, {
    style: {
      marginLeft: "auto",
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement(Row, {
    gutter: [20, 20],
    justify: "end",
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(Statistic, {
    title: __("Total paid commission"),
    valueStyle: {
      color: affiliate.commissions.totalPaid > 0 ? "#3f8600" : undefined
    },
    suffix: "EUR",
    decimalSeparator: decimalSeparator,
    precision: 2,
    value: affiliate.commissions.totalPaid
  })))));
});
export { AccountAffiliateHeader };